import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  FETCH_REVENUE_ANALYSIS_REQUEST,
  fetchRevenueAnalysisFailure,
  fetchRevenueAnalysisSuccess,
} from "../actions/fetchRevenueAnalysisAction";
import { fetchBusinessRevenueAnalysis } from "../../../services/accIqService";

// Worker Saga
function* fetchRevenueAnalysisSaga() {
  try {
    const params = yield select(
      (state) => state?.fetchRevenueAnalysisReducer?.payload
    );
    const { ticker, operating_income } = params;
    const data = yield call(
      fetchBusinessRevenueAnalysis,
      ticker,
      operating_income
    );

    yield put(fetchRevenueAnalysisSuccess(data));
  } catch (error) {
    yield put(fetchRevenueAnalysisFailure(error.message));
  }
}

// Watcher Saga
export function* watchFetchRevenueAnalysis() {
  yield takeLatest(FETCH_REVENUE_ANALYSIS_REQUEST, fetchRevenueAnalysisSaga);
}
